import React, { Component } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

export default class HeadlessLayout extends Component {
  render () {
    return (
      <Layout>
        <Layout>
          <Content>
            {this.props.children}
          </Content>
        </Layout>
      </Layout>
    )
  }
}
